module.exports = __webpack_public_path__ + "static/media/scholar.b4632de2.png";